import React, { useState } from "react";
import { Link } from "react-router-dom";
import Gallery from "react-image-gallery";
import Typography from "@mui/material/Typography";
import Layout from "../components/Layout/Layout";
import "react-image-gallery/styles/css/image-gallery.css";

// Importa las imágenes para la galería
import a from "../images/lumpia_partida.jpg";
import b from "../images/arroz_especial_salon.jpg";
import d from "../images/Soda_michelada_asia_maracuya.jpg";

// Imagen del dragón (se usa en la sección informativa, pero se aplicará overlay para no opacar el texto)
import adjustedImage from "../images/Draguns.webp";

// Importa el componente Figura y el archivo de estilos
import Figura from "../components/Piaces/Figura";
import "./Salon.css";

// Arreglo de imágenes para la galería
const images = [
  { original: a, description: "Descripción de la imagen 1" },
  { original: b, description: "Descripción de la imagen 2" },
  { original: d, description: "Descripción de la imagen 3" },
];

const Salon = () => {
  const phoneNumber = "3023208888";
  const [showGallery] = useState(true);

  return (
    <Layout>
      <div className="salon-container">
        {/* HERO SECTION */}
        <header className="salon-hero">
          <div className="hero-overlay">
            <Typography variant="h1" className="hero-title">
              Disfruta de Nuestro Salón de Eventos
            </Typography>
          </div>
        </header>

        <main className="salon-main">
          {/* BANNER */}
          <section className="salon-banner">
            <p className="banner-text-large">
              Celebra tus eventos especiales con nosotros
            </p>
            <p className="banner-text-small">
              Fiestas, aniversarios, reuniones empresariales y más.
            </p>
            <p className="banner-text-small">¡Reserva ahora!</p>
            <Link to="/menu" className="menu-button">
              Ver Menú
            </Link>
          </section>

          {/* SECCIÓN DE INFORMACIÓN */}
          <section className="salon-info">
            <div className="info-overlay">
              <p>
                En el <strong>Restaurante Asia</strong>, te brindamos la experiencia perfecta para tus eventos. Nuestro amplio salón es ideal para celebrar fiestas, aniversarios y reuniones empresariales.
              </p>
              <p>
                Disfruta de una vista panorámica excepcional y una ubicación privilegiada en Medellín, para que vivas un pedazo de China en un ambiente exclusivo.
              </p>
              <p>
                Además, ofrecemos <strong>WiFi</strong> y una selecta variedad en gastronomía asiática. ¡Crea recuerdos inolvidables junto a tus seres queridos!
              </p>
            </div>
          </section>

          {/* COMENTARIO OPCIONAL: FIGURA */}
          <div className="figura-wrapper">
            <Figura />
          </div>

          {/* SECCIÓN DE EVENTOS */}
          <section className="salon-events">
            <h2 className="section-title">Celebra con Nosotros</h2>
            <p className="events-description">
              Tenemos el espacio ideal para eventos como:
            </p>
            <ul className="events-list">
              <li>
                <span role="img" aria-label="Checkmark">✅</span> Día de la Madre
              </li>
              <li>
                <span role="img" aria-label="Checkmark">✅</span> Cumpleaños
              </li>
              <li>
                <span role="img" aria-label="Checkmark">✅</span> Graduaciones
              </li>
              <li>
                <span role="img" aria-label="Checkmark">✅</span> Matrimonios
              </li>
              <li>
                <span role="img" aria-label="Checkmark">✅</span> Año Nuevo
              </li>
            </ul>
            <p className="events-description">
              Nuestro equipo se asegurará de que cada evento sea único y memorable.
            </p>
          </section>

          {/* Otra FIGURA opcional */}
          <div className="figura-wrapper">
            <Figura />
          </div>

          {/* CALL TO ACTION */}
          <section className="salon-call-to-action">
            <p>
              Llama al número <strong>{phoneNumber}</strong> y reserva tu evento especial.
            </p>
          </section>

          {/* GALERÍA DE IMÁGENES */}
          {showGallery && (
            <div className="gallery-container">
              <Gallery items={images} />
            </div>
          )}
        </main>

        {/* FOOTER */}
        <footer className="salon-footer">
          <p className="footer-text">
            ¿Listo para vivir una experiencia única? ¡Reserva ahora tu evento especial!
          </p>
          <a
            className="footer-button"
            href="tel:6046041005"
            target="_blank"
            rel="noopener noreferrer"
          >
            Reservar Ahora
          </a>
        </footer>
      </div>
    </Layout>
  );
};

export default Salon;
